export const getStartingNumber = (str) => {
    const match = str.match(/\d+/);
    return match ? parseInt(match[0]) : null;
};

export const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);
    if (isNaN(date)) return "N/A";

    const day = date.getDate();
    const month = date.toLocaleString("en-GB", { month: "short" }); // May
    const year = date.getFullYear();
    const time = date.toLocaleString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    }).toUpperCase(); // 12:40 PM

    return `${day} ${month} ${year} - ${time}`;
};

export const capitalizeFirst = (text) => {
    if (!text) return "—";
    return text.charAt(0).toUpperCase() + text.slice(1);
};

export const toAllCaps = (text) => {
    if (!text) return "—";
    return text.toUpperCase();
};

export const formatDateTimeNotEffectTimeZone = (dateString) => {
    if (!dateString) return "N/A";

    // Matches "2026-07-31T22:10:01" (handles "T" or space separator,
    // ignores milliseconds/offset if present)
    const match = String(dateString).match(
        /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/
    );

    if (!match) return "N/A";

    const [, year, month, day, hourStr, minuteStr] = match;

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const monthName = monthNames[parseInt(month, 10) - 1];

    let hours = parseInt(hourStr, 10);
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // 0 -> 12

    return `${parseInt(day, 10)} ${monthName} ${year} - ${hours}:${minuteStr} ${ampm}`;
};

export const buildBlocks = (list) => {
    const parents = list.filter(q => !q.parentFieldId);
    return parents.map(parent => [
        parent,
        ...list.filter(q => q.parentFieldId === parent.id)
    ]);
};

export const flattenWithOrder = (blocks) => {
    const flat = [];
    let order = 0;
    blocks.forEach(block => {
        block.forEach(q => {
            flat.push({ ...q, order: order++ });
        });
    });
    return flat;
};

export const normalizeOrder = (list) => flattenWithOrder(buildBlocks(list));


